export default __webpack_public_path__ + "static/media/trend-up.d74cf22b.svg";